import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { App } from 'app/console-api';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { StatisticsFiltersStyles } from 'app/components/common/common-styles';

type AppOption = {
  id: string;
  value: string;
  label: string;
};

export const AppsFilterAdapter: FilterAdapter<string[]> = {
  key: 'apps',
  fromUrl: (sp) => {
    const raw = sp.get('apps');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('apps');
    } else {
      next.set('apps', value.join(','));
    }
    return next;
  },
  toKey: (v) => `apps:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

type AppsFilterProps = {
  apps: App[];
} & Record<string, any>;

export const AppsFilter = ({ apps, props }: AppsFilterProps) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(AppsFilterAdapter) ?? []; // string[] of selected apps IDs
  const [options, setOptions] = useState<AppOption[]>([]);
  useEffect(() => {
    const opts: AppOption[] = apps.map((app) => ({
      id: app.id,
      value: app.id,
      label: app.name
    }));
    setOptions(opts);
  }, [apps]);

  // react-select multi expects an array of option objects
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select<AppOption, true>
      {...props}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={false}
      styles={StatisticsFiltersStyles()}
      options={options}
      value={selected}
      placeholder={'All apps'}
      onChange={(opts) => {
        const ids = (opts ?? []).map((o) => o.value);
        ctl.set(AppsFilterAdapter, ids.length ? ids : null);
      }}
    />
  );
};
